import React from "react";
import _ from "lodash";
import classnames from "classnames";
import PropTypes from "prop-types";
import { useToggle } from "@sportal/cdk";

import { MobileMenu } from "../MobileMenu/MobileMenu";

import "./UserMenuSidebar.scss";

export const createTitle = (item) => ({
  ...item,
  className: "user-menu-sidebar__menu__title",
  clickable: false,
});
export const createLink = (item) => ({
  ...item,
  className: "user-menu-sidebar__menu__item--link",
  clickable: true,
});
export const createActionItem = (item) => ({
  ...item,
  className: classnames(
    "user-menu-sidebar__menu__item--action-item",
    item.className
  ),
  clickable: true,
});

export const UserMenuSidebar = ({ items }) => {
  const [opened, setOpened] = useToggle(false);

  const onItemClick = (action) => {
    setOpened(false);
    action && action();
  };

  return (
    <MobileMenu toggleState={opened} toggleFn={setOpened}>
      <ul>
        {_.map(items, (item, index) => (
          <li
            className={classnames(
              "user-menu-sidebar__menu__item",
              item.className
            )}
            key={index}
            onClick={
              item.clickable ? () => onItemClick(item.action) : undefined
            }
          >
            {item.content}
          </li>
        ))}
      </ul>
    </MobileMenu>
  );
};

UserMenuSidebar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      action: PropTypes.func,
      content: PropTypes.node,
      clickable: PropTypes.bool,
    })
  ),
};
